import { cloneElement, useState } from "react";
import { Dropdown } from "semantic-ui-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog";
import EditCallForm from "components/forms/EditCallForm";
import CampaignTargetCallService from "services/CampaignTargetCall";

function EditCallModal({
  call: propCall,
  callId,
  callStatuses,
  onSuccess,
  iconTrigger = false,
  trigger,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [call, setCall] = useState({});
  const [callUnavailable, setCallUnavailable] = useState(false);

  const handleOpen = async () => {
    if (!propCall && callId) {
      try {
        const _call = await CampaignTargetCallService.getCall(callId);
        setCall(_call);
      } catch (error) {
        if (error.response.status === 404) {
          setCallUnavailable(true);
        }
      }
    } else {
      setCall(propCall);
    }
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setCallUnavailable(false);
    setCall({});
  };

  const handleSuccess = async () => {
    handleClose();
    await onSuccess();
  };

  const defaultTrigger = iconTrigger ? (
    <Button type="button" variant="outline" size="sm">
      Edit Call
    </Button>
  ) : (
    <Dropdown.Item content="Edit" icon="edit" />
  );

  return (
    <>
      {cloneElement(trigger ?? defaultTrigger, { onClick: handleOpen })}
      <Dialog
        open={modalOpen}
        onOpenChange={open => !open && handleClose()}
        disablePointerDismissal
      >
        <DialogContent className="tw:sm:max-w-4xl">
          <DialogTitle>
            {callUnavailable ? "Call Unavailable" : "Edit Call"}
          </DialogTitle>
          {callUnavailable ? (
            <p>This call is no longer available. It has likely been deleted.</p>
          ) : (
            <EditCallForm
              call={call}
              callStatuses={callStatuses}
              handleClose={handleClose}
              onSuccess={handleSuccess}
            />
          )}
          {callUnavailable && <DialogFooter showCloseButton />}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default EditCallModal;
